import React, { useCallback } from 'react';

import {
  Row,
  Col,
  FormGroup,
  Label
} from 'reactstrap';

import WorkflowHttpRequestBodyResponseList from './content/list';

const WorkflowHttpRequestBodyResponseForm = props => {
  const {
    currentNode,
    callbacks: {
      onSetCurrentNode,
      activeOutputStageFileItems
    }
  } = props;

  // ---------- START ADD BODY RESPONSE CONTENT ITEM ----------
  const onAddBodyResponseContentItem = useCallback(() => {
    const customId = `${ Math.random().toString(36).slice(2) }-${ moment().toDate().getTime() }-${ currentNode?.data?.body_response_content?.length }`;

    let bodyItem = {
      key: '',
      value: '',
      custom_id: customId
    }

    onSetCurrentNode(prevState => {
      return {
        ... prevState,
        data: {
          ... prevState.data,
          body_response_content: [
            ... prevState.data.body_response_content,
            bodyItem
          ]
        }
      }
    })
  }, [])
  // ---------- END ADD BODY RESPONSE CONTENT ITEM ----------
  // ----------------------------------------
  // ---------- START REMOVE BODY RESPONSE CONTENT ITEM ----------
  const onRemoveBodyResponseContentItem = useCallback((customId) => {
    onSetCurrentNode(prevState => {
      return {
        ... prevState,
        data: {
          ... prevState.data,
          body_response_content: _.filter(prevState.data.body_response_content, item => item.custom_id != customId)
        }
      }
    })
  }, [])
  // ---------- END REMOVE BODY RESPONSE CONTENT ITEM ----------//
  // ----------------------------------------
  // ---------- START ON CHANGE BODY RESPONSE CONTENT ITEM ----------
  const onChangeBodyResponseContentItem = useCallback((event, customId) => {
    onSetCurrentNode(prevState => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          body_response_content: _.map(prevState.data.body_response_content, item => {
            if (item.custom_id == customId) {
              return {
                ...item,
                [event.target.name]: event.target.value
              }
            }
            return item
          })
        }
      }
    })
  }, [])
  // ---------- END ON CHANGE BODY RESPONSE CONTENT ITEM ----------

  return (
    <Row>
      <Col md={ 12 }>
        <FormGroup>
          <Label>Body Response Content</Label>

          <WorkflowHttpRequestBodyResponseList
            currentNode={ currentNode }
            callbacks={{
              onSetCurrentNode: onSetCurrentNode,
              activeOutputStageFileItems: activeOutputStageFileItems,
              onAddBodyResponseContentItem: onAddBodyResponseContentItem,
              onRemoveBodyResponseContentItem: onRemoveBodyResponseContentItem,
              onChangeBodyResponseContentItem: onChangeBodyResponseContentItem
            }}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyResponseForm;
